import React from 'react';
import { useTranslation } from 'react-i18next';
import { translate } from '../../../../utils';
import { Select } from '../../../../ui-kit';
import { ActionTypes, useWarehouseCardAction } from '../../providers/WarehouseCardActionProvider';

const getActionTranslation = (availableAction?: ActionTypes) => {
    switch (availableAction) {
    case 'deduction':
        return translate('Write-off');
    default:
        return translate('None');
    }
};

const WarehouseCardAction = () => {
    const { t } = useTranslation();
    const { currentAction, setCurrentAction, availableActions } = useWarehouseCardAction();

    const menuItems = availableActions.map(availableAction => ({
        id: availableAction,
        name: t(...getActionTranslation(availableAction)),
    }));


    const handleActionSwitch = (actionType?: ActionTypes) => {
        setCurrentAction(actionType);
    };

    return (
        <Select
            label={t('Bulk action')}
            dropdownPlacement="bottom-start"
            handleMenuItemClick={handleActionSwitch}
            menuItems={menuItems}
            isDisabled={false}
            selectedId={currentAction}
            selectedName={t(...getActionTranslation(currentAction))}
        />
    );
};

export default WarehouseCardAction;
